import { FunctionComponent } from "react"
import Home from "./pages/Home/Home"
import Profile from "./pages/Profile/Profile/Profile"
import BusinessProfile from "./pages/Profile/BusinessProfile/BusinessProfile"
import Artists from "./pages/Artists/Artists"
import CreateArtist from "./pages/Artists/Create"
import ArtistInspector from "./pages/Artists/inspector"

//art piece
import ArtPieces from "./pages/ArtPieces/ArtPieces"
import ArtPieceInspector from "./pages/ArtPieces/inspector"
import CreateArtPiece from "./pages/ArtPieces/Create"

import Exhibitions from "./pages/Exhibitions/Exhibitions"
import CreateExhibition from "./pages/Exhibitions/Create"
import ExhibitionInspector from "./pages/Exhibitions/inspector"
import Spaces from "./pages/Spaces/Spaces"
import CreateSpace from "./pages/Spaces/Create"
import SpaceInspector from "./pages/Spaces/inspector"
import NoPermission from "./pages/NoPermission/NoPermission"
import Roles from "./pages/Roles/Roles"
import RolesInspector from "./pages/Roles/inspector"
import Artifacts from "./pages/Artifacts/Artifacts"
import ArtifactInspector from "./pages/Artifacts/inspector"
import CreateArtifact from "./pages/Artifacts/Create"
import Assets from "./pages/Assets/Assets"
import AssetInspector from "./pages/Assets/inspector"
import CreateAsset from "./pages/Assets/Create"

import ArTargets from "./pages/ArTargets/ArTargets"
import ArTargetInspector from "./pages/ArTargets/inspector"
import CreateARTarget from "./pages/ArTargets/Create"

import News from "./pages/News/News"
import NewsInspector from "./pages/News/inspector"
import CreateNews from "./pages/News/Create"
import Featured from "./pages/Featured/Featured"
import FeaturedInspector from "./pages/Featured/inspector"

import Packages from "./pages/Packages/Packages"
import CreatePackage from "./pages/Packages/Create"
import PackageInspector from "./pages/Packages/inspector"

import Users from "./pages/Users/Users"
import Test from "./pages/Test/Test"
import UserInspector from "./pages/Users/inspector"

export interface iRoute {
  component: FunctionComponent
  exact: boolean
  path: string
  permission?: string
  childrenRoutes?: Array<iRoute>
}

export const contentRoutes: Array<iRoute> = [
  {
    component: Home,
    exact: true,
    path: "/",
    permission: "Dashboard.Access",
  },
  {
    component: BusinessProfile,
    exact: false,
    path: "/business/profile",
    permission: "Dashboard.Access",
  },
  {
    component: Profile,
    exact: false,
    path: "/profile",
    permission: "Dashboard.Access",
  },
  {
    component: Artists,
    exact: true,
    path: "/artists",
    permission: "Dashboard.Artists",
  },
  {
    path: "/artists/:url",
    permission: "Dashboard.Artists.View",
    exact: false,
    component: ArtistInspector,
  },
  {
    component: CreateArtist,
    exact: false,
    path: "/new/artist",
    permission: "Dashboard.Artists.New",
  },
  {
    component: ArtPieces,
    exact: true,
    path: "/art-pieces",
    permission: "Dashboard.ArtPieces",
  },
  {
    path: "/art-pieces/:url",
    exact: false,
    component: ArtPieceInspector,
    permission: "Dashboard.ArtPieces.View",
  },
  {
    component: CreateArtPiece,
    exact: false,
    path: "/new/art-pieces",
    permission: "Dashboard.ArtPieces.New",
  },
  {
    component: Exhibitions,
    exact: true,
    path: "/exhibitions",
    permission: "Dashboard.Exhibitions",
  },
  {
    component: ExhibitionInspector,
    exact: false,
    path: "/exhibitions/:url",
    permission: "Dashboard.Exhibitions.View",
  },
  {
    component: CreateExhibition,
    exact: false,
    path: "/new/exhibition",
    permission: "Dashboard.Exhibitions.New",
  },
  {
    component: Spaces,
    exact: true,
    path: "/spaces",
    permission: "Dashboard.Spaces",
  },
  {
    component: SpaceInspector,
    exact: false,
    path: "/spaces/:url",
    permission: "Dashboard.Spaces.View",
  },
  {
    component: CreateSpace,
    exact: false,
    path: "/new/space",
    permission: "Dashboard.Spaces.New",
  },
  {
    component: Roles,
    exact: true,
    path: "/roles",
    permission: "Dashboard.Roles",
  },
  {
    component: RolesInspector,
    exact: true,
    path: "/roles/:_id",
    permission: "Dashboard.Roles",
  },
  {
    component: Artifacts,
    exact: true,
    path: "/artifacts",
    permission: "Dashboard.Artifacts",
  },
  {
    component: ArtifactInspector,
    exact: false,
    path: "/artifacts/:url",
    permission: "Dashboard.Artifacts.View",
  },
  {
    component: CreateArtifact,
    exact: true,
    path: "/new/artifact",
    permission: "Dashboard.Artifacts.New",
  },
  {
    component: Assets,
    exact: true,
    path: "/assets",
    permission: "Dashboard.Assets",
  },
  {
    component: AssetInspector,
    exact: false,
    path: "/assets/:url",
    permission: "Dashboard.Assets.View",
  },
  {
    component: CreateAsset,
    exact: true,
    path: "/new/asset",
    permission: "Dashboard.Assets.New",
  },
  {
    component: ArTargets,
    exact: true,
    path: "/ar-targets",
    permission: "Dashboard.ARTargets",
  },
  {
    component: ArTargetInspector,
    exact: false,
    path: "/ar-targets/:url",
    permission: "Dashboard.ARTargets.View",
  },
  {
    component: CreateARTarget,
    exact: false,
    path: "/new/ar-target",
    permission: "Dashboard.ARTargets.New",
  },
  {
    component: News,
    exact: true,
    path: "/news",
    permission: "Dashboard.News",
  },
  {
    component: NewsInspector,
    exact: false,
    path: "/news/:url",
    permission: "Dashboard.News.View",
  },
  {
    component: CreateNews,
    exact: false,
    path: "/new/news",
    permission: "Dashboard.News.New",
  },
  {
    component: Featured,
    exact: true,
    path: "/featured",
    permission: "Dashboard.Featured",
  },
  {
    component: FeaturedInspector,
    exact: true,
    path: "/featured/:_id",
    permission: "Dashboard.Featured.View",
  },
  {
    component: Packages,
    exact: true,
    path: "/packages",
    permission: "Dashboard.Packages",
  },
  {
    component: CreatePackage,
    exact: false,
    path: "/new/package",
    permission: "Dashboard.Packages.New",
  },
  {
    component: PackageInspector,
    exact: false,
    path: "/packages/:_id",
    permission: "Dashboard.Packages.View",
  },
  {
    component: Users,
    exact: true,
    path: "/users",
    permission: "Dashboard.Users",
  },
  {
    component: UserInspector,
    exact: false,
    path: "/users/:_id",
    permission: "Dashboard.Users",
  },
  {
    component: Test,
    exact: true,
    path: "/test",
    permission: "Dashboard.Users",
  },
  {
    component: NoPermission,
    exact: true,
    path: "/no-permission",
  },
]
